import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGrClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 3.11136,
		height: 14.8241,
		rx: .739219,
		transform: "matrix(0.707471 0.706743 -0.706727 0.707487 13.1377 2.65723)",
		fill: "#F25050"
	}), /* @__PURE__ */ _jsx("rect", {
		width: 3.11136,
		height: 14.8241,
		rx: .739219,
		transform: "matrix(-0.707099 0.707115 -0.707099 -0.707115 15.3408 13.1406)",
		fill: "#F25050"
	})]
});
export default SvgGrClose;
